import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.favorite;

const getFavorite = createSelector(getData, favorite => favorite);

export default getFavorite;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getFavorite.js